<template>
  <h2>
    <slot></slot>
  </h2>
</template>

<script>
export default {
  name: "FormHeading",
  props: {},
  data() {
    return {};
  }
};
</script>

<style lang="scss" scoped>
@import "~@/style/_variables.scss";
h2 {
  font-size: $font-size-xxl;
  line-height: $font-size-xxl;
  color: $dark-gray;
  font-weight: 500;

  @media (max-width: $mobile-hd-width) {
    font-size: $font-size-xl;
    line-height: $font-size-xl;
  }
}
svg {
  font-size: $font-size-md;
}
</style>
